import { render, staticRenderFns } from "./Box.vue?vue&type=template&id=d450e7b6&scoped=true&lang=pug"
import script from "./Box.vue?vue&type=script&lang=js"
export * from "./Box.vue?vue&type=script&lang=js"
import style0 from "./Box.styl?vue&type=style&index=0&id=d450e7b6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d450e7b6",
  null
  
)

export default component.exports